
import '../jnanabhumi.css';
import { useEffect, useRef, useState } from "react";
import * as jnb from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate } from 'react-router-dom';
import { VscAccount } from 'react-icons/vsc';
import { IoIosLogOut } from "react-icons/io";
import { FaRegCopy } from 'react-icons/fa';
import Cookies from "js-cookie";
import { calculateTimeLeft, formatTime } from './CommonServices';
import Swal from 'sweetalert2';
import Sweetalert from './SweetAlerts';
import { FcAlarmClock } from "react-icons/fc";

function PublicHeader({ toggleSidebar }) {
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem('user_id');
    const name = sessionStorage.getItem('collegeName');
    const logo = sessionStorage.getItem('collegeLogo');
    const instName = sessionStorage.getItem('instName');
    // affl_admin

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [target, setTarget] = useState(null);
    const [tooltipMessage, setTooltipMessage] = useState('');

    const refreshExpiry = Number(Cookies.get("refreshTokenTime"));
    const [timeLeft, setTimeLeft] = useState('--:--:--');
    const timerRef = useRef(null);

    // State for initialDuration, read from localStorage on mount
    const [initialDuration, setInitialDuration] = useState(() => {
        const storedDuration = localStorage.getItem("refreshTokenDuration");

        return storedDuration ? Number(storedDuration) :
            (refreshExpiry ? refreshExpiry - Date.now() : 0);

    })

    useEffect(() => {
        if (refreshExpiry) {
            const duration = refreshExpiry - Date.now();

            // Save only if different or no stored duration
            const storedDuration = localStorage.getItem("refreshTokenDuration");
            const storedExpiry = localStorage.getItem("refreshTokenExpiry");

            if (!storedDuration || !storedExpiry || Number(storedExpiry) !== refreshExpiry) {
                localStorage.setItem("refreshTokenDuration", duration.toString());
                localStorage.setItem("refreshTokenExpiry", refreshExpiry.toString());
                setInitialDuration(duration);
            }
        } else {
            // Clean localStorage on no token
            localStorage.removeItem("refreshTokenDuration");
            localStorage.removeItem("refreshTokenExpiry");
            setInitialDuration(0);
            setTimeLeft('--:--:--');
        }
    }, [refreshExpiry]);



    useEffect(() => {
        startTimer();

        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [initialDuration]);



    const startTimer = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }

        const storedExpiry = Number(localStorage.getItem("refreshTokenExpiry")) || refreshExpiry;
        if (!storedExpiry) {
            setTimeLeft('--:--:--');
            return;
        }

        const updateTime = () => {
            const remaining = calculateTimeLeft(storedExpiry);
            setTimeLeft(formatTime(remaining));
            if (remaining === 0) {
                Sweetalert('Session Expired', 'warning');
                Swal.fire({
                    text: "Your session has expired. Please Login..",
                    icon: "warning",
                    backdrop: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "OK",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = "/";
                    }
                });
                localStorage.removeItem("refreshTokenDuration");
                localStorage.removeItem("refreshTokenExpiry");
                clearInterval(timerRef.current);
            }
        };

        updateTime();
        timerRef.current = setInterval(updateTime, 1000);
    };



    const handleCopy = (event) => {
        navigator.clipboard.writeText(user_id).then(() => {
            setTooltipMessage('Copied!');
            setShowTooltip(true);
            setTarget(event.target);
            setTimeout(() => setShowTooltip(false), 2000);
        }).catch(() => {
            setTooltipMessage('Failed to copy');
            setShowTooltip(true);
            setTarget(event.target);
            setTimeout(() => setShowTooltip(false), 2000);
        });
    };

    const isAffiliated = user_id === "apsche_affl" || user_id === "prlsecy_he" || user_id === "affl_admin" || user_id === "cce";

    return (
        <>
            <jnb.Navbar className="custom-navbar" collapseOnSelect expand="lg" bg="white" sticky="top" variant="light">
                <jnb.Container fluid style={{ margin: '0px 20px' }}>
                    <Navbar.Brand>
                        <div className="d-flex align-items-center">
                            <div className="text-center">

                                {!isAffiliated && (
                                    <img
                                        src={`https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/Affiliation/${logo}`}
                                        width="55px"
                                        alt="logo"
                                    />
                                )}
                                {isAffiliated && (
                                    <img src="../img/ap-logo.png" className="img-fluid aff-aplogo"
                                        width="55px"
                                        alt="logo"
                                    />
                                )}


                            </div>
                            <div className="affllogo-text text-wrap ">
                                {user_id === "affl_admin" ? instName : (user_id === "apsche_affl" || user_id === "prlsecy_he" || user_id === "cce") ? instName : name}
                            </div>

                        </div>
                    </Navbar.Brand>
                    <jnb.Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <jnb.Navbar.Collapse id="responsive-navbar-nav">
                        <jnb.Nav className="me-auto"></jnb.Nav>
                        <jnb.Nav >
                            <button type='button' style={{ marginLeft: '10px', cursor: 'pointer', lineHeight: '1' }} onClick={() => navigate('/dashboard')}>
                                <VscAccount />

                            </button>

                            <jnb.NavDropdown title={
                                <span style={{ fontSize: "12px", fontFamily: "inherit" }}>
                                    {instName}-{user_id} <br />
                                    <FcAlarmClock size={23} />(Session Expires in) :
                                    <span className="session-time">
                                        {timeLeft}
                                    </span>
                                </span>
                            }
                                className="affl-act ms-0"
                            >
                                <jnb.NavDropdown.Item>
                                    Login: &emsp;{user_id}
                                    &emsp;&emsp;&emsp;&emsp;
                                    <jnb.OverlayTrigger
                                        show={showTooltip}
                                        target={target}
                                        placement="top"
                                        overlay={<jnb.Tooltip id="copy-tooltip">{tooltipMessage}</jnb.Tooltip>}
                                    >
                                        <button
                                            className="btn btn-secondary btn-sm ml-2"
                                            onClick={handleCopy}
                                        >
                                            <FaRegCopy />&nbsp; Copy
                                        </button>
                                    </jnb.OverlayTrigger>


                                </jnb.NavDropdown.Item>

                                <jnb.NavDropdown.Item href='/'>
                                    Sign Out <IoIosLogOut />

                                </jnb.NavDropdown.Item>
                            </jnb.NavDropdown>
                        </jnb.Nav>
                    </jnb.Navbar.Collapse>

                </jnb.Container>

            </jnb.Navbar>
            <jnb.Modal show={showModal} onHide={handleCloseModal} size="md" backdrop={false}>
                <jnb.Modal.Header closeButton>
                    <jnb.Modal.Title>Institution Details:</jnb.Modal.Title>
                </jnb.Modal.Header>
                <jnb.Modal.Body  >
                    <p><strong style={{ color: "brown" }}>Institute Name:</strong> {instName}</p>
                    <p><strong style={{ color: "brown" }}>UserID:</strong> {user_id}</p>
                </jnb.Modal.Body>
                <jnb.Modal.Footer>
                    <jnb.Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </jnb.Button>
                    <jnb.Button variant="primary">
                        Update Profile
                    </jnb.Button>
                </jnb.Modal.Footer>
            </jnb.Modal>
        </>
    );

}
export default PublicHeader;



